import { KycFunctionType } from "../http/protocol";

/**
 * Maps KYC function type enum values to user-friendly display names.
 * This allows us to change display names without modifying database values.
 * 
 * Note: REGISTRATION is displayed as "Registration & Login" since it requires KYC
 * at both registration and login, not just registration.
 */
export function getKycFunctionTypeDisplayName(functionType: KycFunctionType): string {
    switch (functionType) {
        case KycFunctionType.ALL:
            return "All";
        case KycFunctionType.REGISTRATION:
            return "Registration & Login";
        case KycFunctionType.WITHDRAW:
            return "Withdraw";
        case KycFunctionType.DEPOSIT:
            return "Deposit";
        case KycFunctionType.PLAY:
            return "Play";
        case KycFunctionType.KYC_AVAILABLE:
            return "KYC Available";
        default:
            return functionType;
    }
}

